import Tools from './../components/tools';
import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Home {
  constructor() {
    // Home
    gsap.registerPlugin(ScrollTrigger);

    this.CONTACTBTNSIZE = (document.querySelector('section .contact')) ? document.querySelector('section .contact').offsetWidth : 0;
    this.contactSize();
    this.sliders();
    this.contactDisplay();
    this.player();
    this.animationsHeader();
    this.animationsContent();

    window.addEventListener('resize', () => {
      this.contactSize();
    });
  }

  contactSize() {
    const contactBtn = document.querySelector('section .contact');
    if (contactBtn && window.innerWidth > 1023) {
      const size = (window.innerWidth - document.querySelector('section .container').offsetWidth) / 2 + this.CONTACTBTNSIZE;
      contactBtn.style.width = `${size}px`;
    } else {
      contactBtn.style.width = '';
    }
  }

  contactDisplay() {
    const contactBtn = document.querySelector('section .contact');
    if (contactBtn) {
      window.addEventListener('scroll', () => {
        if (window.pageYOffset < 1) {
          contactBtn.classList.remove('small');
        } else {
          contactBtn.classList.add('small');
        }
      });
    }
  }

  sliders() {
    const imagesWrapper = document.querySelectorAll('section article .cols');
    if (imagesWrapper.length > 0) {
      imagesWrapper.forEach((item) => {
        tns({
          container: item.querySelector('.col .images-container'),
          items: 1,
          slideBy: 'page',
          autoplay: false,
          navPosition: 'bottom',
          navContainer: item.querySelector('.col .pagination'),
          controlsContainer: item.querySelector('.col .custom-controls'),
          loop: true,
        });
      });
    }

    const sliderTemoignage = document.querySelector('section article .temoignage-slider');
    if (sliderTemoignage) {
      tns({
        container: sliderTemoignage,
        items: 1,
        slideBy: 'page',
        autoplay: false,
        navPosition: 'bottom',
        loop: true,
        controls: false,
        // gutter: 100,
      });
    }
  }

  player() {
    const players = document.querySelectorAll('section article .player');
    if (players.length > 0) {
      players.forEach((player) => {
        player.querySelector('.play').addEventListener('click', () => {
          player.classList.add('is-playing');
          player.querySelector('video').play();
        });
      });

      // player.querySelector('video').addEventListener('pause', () => {
      //   player.classList.remove('is-playing');
      // });
    }
  }

  animationsHeader() {
    const titre = document.querySelector('section header .text-container h1 strong');
    if (titre) {
      gsap.to(
        titre,
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power4.out',
          delay: 0.2,
        }
      );
    }

    const soustitre = document.querySelectorAll('section header .text-container h1 span');
    if (soustitre) {
      gsap.to(
        soustitre,
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power4.out',
          delay: 0.3,
        }
      );
    }

    const image = document.querySelector('section header figure');
    if (image) {
      gsap.to(
        image,
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power4.out',
          delay: 0.5,
        }
      );
    }

    const frontImage = document.querySelector('section header .front-img');
    if (frontImage) {
      gsap.to(
        frontImage,
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power4.out',
          delay: 0.7,
        }
      );
    }
  }

  animationsContent() {
    const elements = document.querySelectorAll('section article h2, section article .text-container, section article .push, section article .player, section article .cols .col, section article.ux .cta, section article.dark.more .cta, section article#tarifs .sub-title');
    elements.forEach((elt) => {
      gsap.to(
        elt,
        {
          scrollTrigger: {
            trigger: elt,
            start: 'top 90%'
          },
          ease: 'power4.out',
          duration: 1.25,
          opacity: 1,
          y: 0,
          delay: 0.2,        }
      );
    });

    const items = document.querySelectorAll('section article .tarifs .item');
    gsap.to(
      items,
      {
        scrollTrigger: {
          trigger: document.querySelector('section article .tarifs'),
          start: 'top 90%'
        },
        ease: 'power4.out',
        duration: 1.25,
        opacity: 1,
        y: 0,
        delay: 0.2,
        stagger: 0.2,
      }
    );
  }
}